import type { IPerson } from '../api/domain/channelsuite/user-services/customer-master-data';

export const isUndefinedOrNaN = (value: any) => value === undefined || Number.isNaN(value);
export const getDisplayName = (person?: IPerson) => person?.displayName || `${person?.firstName || ''} ${person?.lastName || ''}`.trim();
